import {
  IAMUserState,
  JsonSchemaPropertyMap,
  RowDataValueType,
} from "../../../../types";
import { getFieldDisplayValue } from "../exportRecordsHelpers";

// maps the groupId,enums to respective labels for display in the table

export const getFormattedDisplayLabel = (
  propertySubKey: string,
  inputValue: RowDataValueType,
  correlationProperties: JsonSchemaPropertyMap,
  setupName: string,
  iamUserState: IAMUserState,
): RowDataValueType => {
  const property = correlationProperties[propertySubKey];
  if (!property || (!property.isGroupId && !property.enum)) {
    return inputValue;
  }
  return getFieldDisplayValue({
    value: inputValue,
    fieldName: propertySubKey,
    setupName: setupName,
    property,
    iamUserState,
  });
};
